import React, { useState } from 'react';
import { BrutalCard, BrutalButton } from '@/components/brutal';

// Shown before a child's recording is shared outside the family. The server also refuses without consent.
const COPY = {
  gallery: {
    title: 'Share to the public Audio Book collection?',
    points: [
      'Anyone who visits the collection can listen to this recording.',
      'Only your child’s first name and an age range are shown.',
      'A person on our team reviews it before it appears. You can remove it at any time by archiving the recording.',
    ],
    agree: 'I am this child’s parent or guardian and I agree to share this recording publicly.',
  },
  link: {
    title: 'Create a public link?',
    points: [
      'Anyone you give the link to can listen to this recording, and can pass the link on.',
      'The link works for 30 days, and stops working immediately if you archive the recording.',
      'Your child’s name and age appear on the page.',
    ],
    agree: 'I am this child’s parent or guardian and I agree to create this public link.',
  },
  bee: {
    title: 'Enter this recording in the Reading Bee?',
    points: [
      'Other participants in this Reading Bee can listen to the recording and score it.',
      'Your child’s name and age are shown with the entry.',
    ],
    agree: 'I am this child’s parent or guardian and I agree to enter this recording.',
  },
};

const MediaConsentDialog = ({ kind, onConfirm, onCancel }) => {
  const [agreed, setAgreed] = useState(false);
  const c = COPY[kind];
  if (!c) return null;
  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={onCancel} role="dialog" aria-modal="true" data-testid="media-consent-dialog">
      <div onClick={(e) => e.stopPropagation()} className="max-w-md w-full">
        <BrutalCard className="p-5 bg-white">
          <h3 className="text-xl font-black uppercase mb-3">{c.title}</h3>
          <ul className="list-disc pl-5 space-y-1 text-sm mb-4">
            {c.points.map((p) => <li key={p}>{p}</li>)}
          </ul>
          <label className="flex gap-2 items-start text-sm font-bold mb-4">
            <input type="checkbox" className="mt-1" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} data-testid="media-consent-checkbox" />
            <span>{c.agree}</span>
          </label>
          <div className="flex gap-2">
            <BrutalButton variant="amber" disabled={!agreed} onClick={() => onConfirm()} data-testid="media-consent-confirm">Agree and continue</BrutalButton>
            <BrutalButton onClick={onCancel}>Cancel</BrutalButton>
          </div>
        </BrutalCard>
      </div>
    </div>
  );
};

export default MediaConsentDialog;
